module.exports = __webpack_public_path__ + "img/thumb_14.c1d2a246.jpg";